module.exports = __webpack_public_path__ + "static/media/logo-yoho.e710a1a2.png";